import React, { useEffect, useState } from 'react'
import { Menu as KendoMenu } from '@progress/kendo-react-layout';
import { createMenuItems, createStandardMenuItems } from './MenuHelper';

import './Menu.scss'

interface IMenu {
  menuItems: any;
  objectKey: string;
  onClick: (item: string) => void;
  vertical?: boolean;
  isCamelCaseItems?: boolean;
  selectedTab?: string;
}

/**
 *
 * @param menuItems any - this accepts in a array of object
 * @param objectKey string - pass in a string of the menuItem objects property you'd like to have showing in the menu
 * @param onClick (item: string)=>void - This sends the key value selected on menu item click (same as the key passed in)
 * @example
 * <Menu
 *  menuItems={[{text: 'MenuItem1'}, {text: 'MenuItem2'}]}
 *  objectKey='filingFormTypeName'
 *  onClick={(selected:string)=>{console.log(selected)}}
 * />
 * @returns React.Component
 */
const Menu = (props: IMenu) => {
  const [items, setItems] = useState<any[]>([]);
  const { menuItems, objectKey, vertical, isCamelCaseItems, selectedTab } = props;

  useEffect(() => {
    if (objectKey && objectKey !== null && menuItems.length > 1 && isCamelCaseItems) {
      let items : any[] = createMenuItems(menuItems, objectKey);
      if (selectedTab && selectedTab !== null) {
        let selectedIndex = items.findIndex(x => x.text === selectedTab || x.text === selectedTab.match(/[A-Z][a-z]+|[0-9]+/g)!.join(' '));
        if (selectedIndex >= 0) {
          items[selectedIndex] = { ...items[selectedIndex], cssClass: "active-menu-item" };
        }
      }
      setItems(items);
    } else if (objectKey && objectKey !== null && menuItems.length > 1) {
      let items : any[] = createStandardMenuItems(menuItems, objectKey);
      let selectedIndex = items.findIndex(x => x.text === selectedTab);
      if (selectedIndex >= 0) {
        items[selectedIndex] = { ...items[selectedIndex], cssClass: "active-menu-item" };
      }
      setItems(items);
    }
    else {
      setItems([]);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [menuItems, objectKey, selectedTab])

  return (
    <div className="custom-menu">
      <KendoMenu
        vertical={vertical ? vertical : false}
        items={items}
        onSelect={(event: any) => props.onClick(event.item)}
      />
    </div>
  )
}

export default Menu